export default __webpack_public_path__ + "static/AvenirLTStd-BookOblique-fad64df799187c35cfbabb62b59159b2.woff2";